/**
 * トリガー質問選択メタデータ
 */
export type TriggerQuestionSelectMeta = {
  /**
   * カテゴリ名
   */
  categoryName: string;
  /**
   * 質問表示番号
   */
  questionDisplayNumber: string;
  /**
   * 選択肢テキスト
   */
  selectText: string;
};

/**
 * トリガー質問選択メタデータであるかどうか
 */
export const isTriggerQuestionSelectMeta = (
  value: unknown
): value is TriggerQuestionSelectMeta => {
  if (typeof value !== 'object' || Array.isArray(value) || value === null) {
    return false
  }

  const obj = value as Record<string, unknown>

  if (
    !Object.prototype.hasOwnProperty.call(obj, 'categoryName') ||
    !Object.prototype.hasOwnProperty.call(obj, 'questionDisplayNumber') ||
    !Object.prototype.hasOwnProperty.call(obj, 'selectText') ||
    typeof obj.categoryName !== 'string' ||
    typeof obj.questionDisplayNumber !== 'string' ||
    typeof obj.selectText !== 'string'
  ) {
    return false
  }

  return true
}

/**
 * 条件分岐メッセージ
 */
export const conditionalBranchMessage = (
  args: any,
  callback: (
    triggerQuestionSelectMetaList: TriggerQuestionSelectMeta[]
  ) => string
) => {
  const values = Object.entries(args.values).map(([_key, value]) => ({
    ...((value ?? {}) as Record<string, any>),
  }))

  if (
    typeof values !== 'object' ||
    values === null ||
    !values.every(isTriggerQuestionSelectMeta) ||
    values.length === 0
  ) {
    return ''
  }

  return callback(values)
}
